<template>
<!--  DEPARTURE / FORWARD TICKET -->
  <div class="row">
    <OrderInfoItemWrapperComponent :data-class-name="'__data-1'"
                                   :translate-key="'drive_from'">
      <template #icon-item>
        <img src="/assets/images/Framelocation-icon.png" alt="location">
      </template>
      <template #order-info>
        {{ orderData.forwardTicket.pickUp.address_to_show }}, {{ orderData.forwardTicket.pickUp.city }} {{ (orderData.forwardTicket.pickup_specified_address.length > 0) ? `(${orderData.forwardTicket.pickup_specified_address})` : '' }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-2'"
                                   :translate-key="'departure'">
      <template #icon-item>
        <img src="/assets/images/Framecalendar-icon.png" alt="pickup-date-time">
      </template>
      <template #order-info>
        {{ dateHelpers.dateToDisplay(orderData.forwardTicket.tripDate) }} {{ tripTimeForward.departure }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent
        :data-class-name="'__data-3'"
        :translate-key="'stops'"
        data-bs-toggle="modal"
        :data-bs-target="`#transportation-route-map-${orderData.forwardTicket.data.id}`">
      <template #icon-item>
        <img src="/assets/images/plus-circle-plus-svg.svg"
             alt="end-date-time"
             @mouseover="onHover($event)"
             @mouseout="onUnHover($event)">
      </template>
      <template #order-info>
        {{ orderData.forwardTicket.data.transportation_stop.length }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-4'"
                                   :translate-key="'arrival'">
      <template #icon-item>
        <img src="/assets/images/Framecalendar-icon.png" alt="end-date-time">
      </template>
      <template #order-info>
        {{ dateHelpers.dateToDisplay(orderData.forwardTicket.tripDate) }} {{ tripTimeForward.arrival }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-5'"
                                   :translate-key="'drive_to'">
      <template #icon-item>
        <img src="/assets/images/Framedestination.png" alt="end-date-time">
      </template>
      <template #order-info>
        {{ orderData.forwardTicket.dropOff.address_to_show }}, {{ orderData.forwardTicket.dropOff.city }} {{ (orderData.forwardTicket.dropoff_specified_address.length > 0) ? `(${orderData.forwardTicket.dropoff_specified_address})` : '' }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-6'"
                                   :translate-key="'passengers'">
      <template #icon-item>
        <img src="/assets/images/Framepeople-icon.png" alt="people-count">
      </template>
      <template #order-info>
        {{ orderData.tripPassengers }}
      </template>
    </OrderInfoItemWrapperComponent>
  </div>

  <div class="col-sm-12 col-md-12 col-lg-11 hr-line"></div>

<!-- ARRIVAL / BACK TICKET -->
  <div class="row">
    <OrderInfoItemWrapperComponent :data-class-name="'__data-1'"
                                   :translate-key="'drive_from'">
      <template #icon-item>
        <img src="/assets/images/Framelocation-icon.png" alt="location">
      </template>
      <template #order-info>
        {{ orderData.backTicket.pickUp.address_to_show }}, {{ orderData.backTicket.pickUp.city }} {{ (orderData.backTicket.pickup_specified_address.length > 0) ? `(${orderData.backTicket.pickup_specified_address})` : '' }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-2'"
                                   :translate-key="'departure'">
      <template #icon-item>
        <img src="/assets/images/Framecalendar-icon.png" alt="pickup-date-time">
      </template>
      <template #order-info>
        {{ dateHelpers.dateToDisplay(orderData.backTicket.tripDate) }} {{ tripTimeBack.departure }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent
        :data-class-name="'__data-3'"
        :translate-key="'stops'"
        data-bs-toggle="modal"
        :data-bs-target="`#transportation-route-map-${orderData.backTicket.data.id}`">
      <template #icon-item>
        <img src="/assets/images/plus-circle-plus-svg.svg"
             alt="end-date-time"
             @mouseover="onHover($event)"
             @mouseout="onUnHover($event)">
      </template>
      <template #order-info>
        {{ orderData.backTicket.data.transportation_stop.length }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-4'"
                                   :translate-key="'arrival'">
      <template #icon-item>
        <img src="/assets/images/Framecalendar-icon.png" alt="end-date-time">
      </template>
      <template #order-info>
        {{ dateHelpers.dateToDisplay(orderData.backTicket.tripDate) }} {{ tripTimeBack.arrival }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-5'"
                                   :translate-key="'drive_to'">
      <template #icon-item>
        <img src="/assets/images/Framedestination.png" alt="end-date-time">
      </template>
      <template #order-info>
        {{ orderData.backTicket.dropOff.address_to_show }}, {{ orderData.backTicket.dropOff.city }} {{ (orderData.backTicket.dropoff_specified_address.length > 0) ? `(${orderData.backTicket.dropoff_specified_address})` : '' }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-6'"
                                   :translate-key="'passengers'">
      <template #icon-item>
        <img src="/assets/images/Framepeople-icon.png" alt="people-count">
      </template>
      <template #order-info>
        {{ orderData.tripPassengers }}
      </template>
    </OrderInfoItemWrapperComponent>
  </div>
  <ModalComponent :show-title="false" :id-data="`transportation-route-map-${orderData.forwardTicket.data.id}`">
    <template #body-content>
      <TransportationStopsModalContentComponent :data="orderData.forwardTicket.data"/>
    </template>
  </ModalComponent>

  <ModalComponent :show-title="false" :id-data="`transportation-route-map-${orderData.backTicket.data.id}`">
    <template #body-content>
      <TransportationStopsModalContentComponent :data="orderData.backTicket.data"/>
    </template>
  </ModalComponent>
  <div class="col-sm-12 col-md-12 col-lg-11 hr-line"></div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
// @ts-ignore
import OrderInfoItemWrapperComponent from "../../orderInfoItemWrapper/OrderInfoItemWrapperComponent.vue";
// @ts-ignore
import ModalComponent from "../../../modal/ModalComponent.vue";
// @ts-ignore
import TransportationStopsModalContentComponent from "../../../transportationStopsModalContent/TransportationStopsModalContentComponent.vue";
import {dateHelpers} from "../../../../helpers/dateHelpers";

export default defineComponent({
  name: 'RoundTripTrueWrapperComponent',
  components: {
    TransportationStopsModalContentComponent,
    ModalComponent,
    OrderInfoItemWrapperComponent
  },
  props: {
    orderData: {
      type: Object
    }
  },
  data() {
    return {

    }
  },

  computed: {
    dateHelpers() {
      return dateHelpers
    },
    tripTimeForward() {
      return this.tripTime(true);
    },
    tripTimeBack() {
      return this.tripTime(false);
    }
  },

  methods: {
    tripTime(isForward: boolean): { departure: string, arrival: string } {
      const ticket = isForward ? this.orderData!.forwardTicket : this.orderData!.backTicket;

      const data = this.allAddresses(ticket.data);

      const departure = data.find(item => item.id === ticket.pickUp.id)!.time;
      const arrival = data.find(item => item.id === ticket.dropOff.id)!.time;

      return {departure, arrival};
    },

    allAddresses(data: any): {id: number, time: string, city: string}[] {
      return [
        {
          id: data.pickup_city.id,
          time: data.pickup_time,
          city: data.pickup_city.address_to_show
        },
        ...data.transportation_stop.map(stop => {
          return {
            id: stop.transportation_address.id,
            time: stop.time,
            city: stop.transportation_address.address_to_show
          }
        }),
        {
          id: data.dropoff_city.id,
          time: data.drop_off_time,
          city: data.dropoff_city.address_to_show
        }
      ];
    },

    onHover($event: MouseEvent): void {
      ($event.target! as HTMLElement).setAttribute('src','images/plus-circle-plus-svg-blue.svg');
    },
    onUnHover($event: MouseEvent): void {
      ($event.target! as HTMLElement).setAttribute('src','images/plus-circle-plus-svg.svg');
    },
  },

})
</script>

<style scoped>
img:hover {
  cursor: pointer;
}
</style>